import NoMockAllocationIcon from '@cp/src/assets/icons/NoMockAllocationIcon';
import { Typography } from '@navi/web-ui/lib/primitives';

const EmptyState = (props: { message: string }) => {
  const { message } = props;
  return (
    <div className="w-full h-full flex flex-col items-center justify-center gap-5">
      <NoMockAllocationIcon />
      <Typography variant="h4" color="var(--grayscale-2)">
        {message}
      </Typography>
    </div>
  );
};

export default EmptyState;
